var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDrag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "drag_svg__svg-icon",
    style: {
      width: "2em",
      height: "2em",
      verticalAlign: "middle"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    overflow: "hidden"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M469.333 256A85.333 85.333 0 11384 170.667 85.333 85.333 0 01469.333 256zM384 426.667A85.333 85.333 0 10469.333 512 85.333 85.333 0 00384 426.667zm0 256A85.333 85.333 0 10469.333 768 85.333 85.333 0 00384 682.667zm256-341.334A85.333 85.333 0 10554.667 256 85.333 85.333 0 00640 341.333zm0 85.334A85.333 85.333 0 10725.333 512 85.333 85.333 0 00640 426.667zm0 256A85.333 85.333 0 10725.333 768 85.333 85.333 0 00640 682.667z"
  })));
}

export default SvgDrag;